import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ChevronRightBold } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from 'components/Product/Promotion/Description/PromotionDescription.scss';

const SimplePromotionDescription = ({
  description,
  underlineText = false,
  noMargin = false,
  backgroundColor,
  myWaitrosePromotion = false,
  isLink = false,
  withChevron = false,
}) => {
  return (
    <p
      className={classNames(styles.offerDescription, {
        [styles.noMargin]: noMargin,
        [styles.withBackground]: !!backgroundColor,
        [styles.green]: backgroundColor === 'green' || myWaitrosePromotion,
      })}
      data-testid="simple-promotion-description"
    >
      <span
        data-testid="description"
        className={classNames({
          [styles.underline]: underlineText,
        })}
      >
        {description}
      </span>
      {backgroundColor && isLink && withChevron && (
        <ChevronRightBold size="xsmall" className={styles.chevronIcon} />
      )}
    </p>
  );
};

SimplePromotionDescription.displayName = 'SimplePromotionDescription';

SimplePromotionDescription.propTypes = {
  description: PropTypes.string.isRequired,
  underlineText: PropTypes.bool,
  noMargin: PropTypes.bool,
  backgroundColor: PropTypes.string,
  isLink: PropTypes.bool,
  withChevron: PropTypes.bool,
  myWaitrosePromotion: PropTypes.bool,
};

export default memo(SimplePromotionDescription);
